<template>
	<div class="sp-template">
		<div class="h-title">批次成本管理</div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
          <el-form-item label="供应商">
						<el-select v-model="conditions.supplierId" filterable clearable>
              <el-option v-for="item in suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
					</el-form-item>
          <el-form-item label="费用类型">
						<el-select v-model="conditions.serviceTypeId" filterable clearable>
              <el-option v-for="item in serviceTypes" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
					</el-form-item>
          <el-form-item label="状态">
            <el-select v-model="conditions.status" clearable>
              <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
					</el-form-item>
          <el-form-item label="开始日期">
            <el-date-picker v-model="conditions.startDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker v-model="conditions.endDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="批次号">
            <el-input v-model="conditions.batchIdTextArea" type="textarea" placeholder="多个批次号用回车分割"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button v-if="in_configs(41601)" type="primary" @click="search">搜索</el-button>
					</el-form-item>
				</el-form>
			</div>
      <div class="table-button__groups">
        <div class="button-groups">
          <el-button v-if="in_configs(41602)" size="small" @click="costImport">成本差价补录</el-button>
          <el-button v-if="in_configs(41603)" size="small" @click="exportData">导出</el-button>
          <el-button v-if="in_configs(41604)" size="small" @click="batchCheck">批量核销</el-button>
        </div>
      </div>
			<el-table ref="multipleTable" v-loading="loading" :data="tableData" @selection-change="handleSelectionChange" stripe border style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="batchId" label="批次号"></el-table-column>
				<el-table-column prop="airWaybill" label="提单号"></el-table-column>
				<el-table-column label="供应商">
          <template slot-scope="scope" >
						{{scope.row.supplierId == null ? "" : supplierMap[scope.row.supplierId]}}
					</template>
        </el-table-column>
				<el-table-column prop="totalOrder" label="订单总数"></el-table-column>
				<el-table-column prop="totalCarton" label="箱数"></el-table-column>
				<el-table-column prop="totalWeight" label="实重"></el-table-column>
				<el-table-column prop="totalBillWeight" label="系统计费重"></el-table-column>
				<el-table-column prop="batchBillWeight" label="批次计费重"></el-table-column>
				<el-table-column prop="totalVolume" label="体积(cbm)"></el-table-column>
        <el-table-column prop="serviceTypeId" label="费用类型">
          <template slot-scope="scope" >
						{{scope.row.serviceTypeId == null ? "" : serviceTypeMap[scope.row.serviceTypeId]}}
					</template>
        </el-table-column>
				<el-table-column prop="amount" label="金额"></el-table-column>
				<el-table-column prop="trace" label="计算明细"></el-table-column>
				<el-table-column prop="remarks" label="备注"></el-table-column>
				<el-table-column label="状态">
          <template slot-scope="scope" >
						{{scope.row.status == "HAS_CHECK" ? "已核对" : (scope.row.status == "HAS_PAYMENT" ? "已付款" : "")}}
					</template>
        </el-table-column>
				<el-table-column prop="createDate" label="计费时间" width="110px"></el-table-column>
				<el-table-column prop="operator" label="操作者"></el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>

      <el-dialog title="成本差额补录" :visible.sync="dialogVisible" width="500px">
        <el-form size="small" style="border-bottom:1px solid #eee;" >
          <el-form-item label="上传文件" label-width="80px">
            <el-upload action="#" name="upload" :limit="1" list-type="text" accept=".xlsx,.xls" 
            :on-change="handlePictureCardChange" :on-remove="handleRemove" :auto-upload="false"
            :file-list="fileList" style="display: inline-block;">
              <el-button slot="trigger" size="mini" type="primary">选取文件</el-button>
            </el-upload>
            <a href="../../../static/template/batch_cost_charge.xlsx" download="batch_cost_charge.xlsx" style="margin-left:50px;display: inline-block; vertical-align: top;">
              <el-button size="small" type="text">下载模板</el-button>
            </a>
          </el-form-item>
        </el-form>
        <div slot="footer" >
          <el-button class="dialog-footer" size="small" type="primary" @click="dialogVisible = false" >取消</el-button>
          <el-button class="dialog-footer" size="small" type="primary" @click="costChargeImport(false)" >提交</el-button>
        </div>
      </el-dialog>

      <el-dialog title="修改状态" :visible.sync="dialogVisible1" width="500px">
        <el-form size="small" label-width="80px">
          <el-form-item label="状态:">
            <el-select v-model="status" clearable>
              <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" >
          <el-button class="dialog-footer" size="small" type="primary" @click="dialogVisible1 = false" >取消</el-button>
          <el-button class="dialog-footer" size="small" type="primary" @click="updateStatus" >确认</el-button>
        </div>
      </el-dialog>
      <el-dialog title="提示" :visible.sync="dialogVisible3" width="500px">
        <span>{{costImportMsg}}</span>
        <div slot="footer" >
          <el-button class="dialog-footer" size="small" type="primary" @click="continueUpload" >{{isCancel ? "取消" : "继续上传"}}</el-button>
          <el-button class="dialog-footer" size="small" type="primary" @click="downloadCostFile" >下载excel文件</el-button>
        </div>
      </el-dialog>
		</el-card>
	</div>
</template>
<script>
import { Loading } from "element-ui";
import { getToken } from '@/util/auth' // get token from cookie
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'

export default {
  data() {
    return {
      status: "",
      suppliers: [],
      supplierMap: {},
      serviceTypes: [],
      serviceTypeMap: {},
      conditions: {
        batchIdTextArea: "",
        supplierId: "",
        serviceTypeId: "",
        status: "",
        startDate: "",
        endDate: ""
      },
      statusList: [
        {
          id: "HAS_CHECK",
          name: "已核对"
        },
        {
          id: "HAS_PAYMENT",
          name: "已付款"
        }
      ],
      tableData: [],
      multipleSelection: [],
      total: 1, //总条数
      currentPage: 1, //当前页
      pageSize: 10, //当前显示条数
      pageSizes: [10, 20, 50, 100], //显示条数
      loading: true,
      dialogVisible: false,
      dialogVisible1: false,
      fileList: [],
      dialogVisible3: false,
      costImportMsg: "",
      costFile: "",
      isCancel: false
    };
  },
  created() {
    setTimeout(() => {
      this.loading = false;
      this.querySupplier();
      this.queryServiceType();
      this.query();
    }, 1000);
  },
  methods: {
    //搜索
    search() {
      this.currentPage = 1;
      this.query();
    },
    //加载数据
    query() {
      let batchIds = [];
      this.conditions.batchIdTextArea.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          batchIds.push(d);
        }
      });
      this.$request1({
        method: 'post',
        url: '/batch/cost-charge/query',
        data: {
          batchIds: batchIds,
          supplierId: this.conditions.supplierId,
          serviceTypeId: this.conditions.serviceTypeId,
          status: this.conditions.status,
          startDate: this.conditions.startDate,
          endDate: this.conditions.endDate,
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
      })
        .then(response => {
          if (response.data.success) {
            this.tableData = response.data.data;
            this.total = response.data.total;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //分页
    handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.query();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.query();
    },
    // 供应商名称
    querySupplier() {
      this.$request1({
        method: 'GET',
        url: '/supplier'
      })
        .then(response => {
          this.suppliers = response.data;
          if (this.suppliers != null && this.suppliers.length > 0) {
            this.suppliers.forEach(item => {
              this.supplierMap[item.id] = item.name;
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 服务类型
    queryServiceType() {
      this.$request1({
        method: 'GET',
        url: '/system/map/supplier-service-type'
      })
        .then(response => {
          this.serviceTypes = response.data;
          if (this.serviceTypes != null && this.serviceTypes.length > 0) {
            this.serviceTypes.forEach(item => {
              this.serviceTypeMap[item.code] = item.name;
            });
          }
        })
        .catch(error => {
          this.$message.error("操作失败");
        });
    },
    batchCheck() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请选择批次成本费用",
          type: "warning"
        });
        return;
      }
      this.status = "";
      this.dialogVisible1 = true;
    },
    updateStatus() {
      if (this.status.length == 0) {
        this.$message({
          message: "请选择状态",
          type: "warning"
        });
        return;
      }
      let msg = this.status == "HAS_CHECK" ? "已核对" : "已付款";

      this.$confirm("是否将勾选的费用改为" + msg + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let ids = this.multipleSelection.map(a => a.id);
          this.$request1({
            method: 'post',
            url: '/batch/cost-charge/update',
            headers: { "content-type": "application/json" },
            responseType: "json",
            params: {
              id: ids.toString(),
              status: this.status
            }
          })
            .then(response => {
              if (response.data.success) {
                this.dialogVisible1 = false;
                this.$message({
                  message: "成功",
                  type: "success"
                });
                this.query();
              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {});
    },
    handlePictureCardChange(file, fileList) {
      this.fileList.push(file);
    },
    handleRemove(file, fileList) {
      this.fileList = [];
    },
    costImport() {
      this.fileList = [];
      this.dialogVisible = true;
    },
    costChargeImport(continueUpload) {
      if (this.fileList.length == 0) {
        this.$message.error("请选择导入文件");
        return;
      }

      var formData = new FormData();
      if (this.fileList.length > 0) {
        formData.append("file", this.fileList[0].raw);
      }
      formData.append("continueUpload", continueUpload);

      const instance = this.$axios.create({
        baseURL: tmsSpringUrl,
        withCredentials: true,
        timeout: 300000
      });

      let loadingInstance;
      instance.interceptors.request.use(
        config => {
          loadingInstance = Loading.service({
            text: "正在提交。。。。数据量太大时间会比较久，请不要重复提交。",
            lock: true,
            fullscreen: true,
            background: "rgba(0, 0, 0, 0.8)",
            spinner: "el-icon-loading"
          });
          let t = getToken()
          config.headers['tmsSpringToken'] = !t || t == 'undefined' ? '' : t
          return config;
        },
        error => {
          loadingInstance.close();
          if (error.response && error.response.status == 401) {
            // todo-login
            // var r = '/login';
            // window.location.href = r;
          }
          return Promise.reject(error);
        }
      );
      instance.interceptors.response.use(
        function(response) {
          loadingInstance.close();
          return response;
        },
        function(error) {
          loadingInstance.close();
          this.fileList = [];
          if (error.response && error.response.status == 401) {
            // todo-login
            // var r = '/login';
            // window.location.href = r;
          }
          return Promise.reject(error);
        }
      );

      instance({
        method: 'POST',
        url: '/batch/cost-charge/import',
        data: formData,
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(res => {
          if (res.data.success) {
            this.dialogVisible = false;
            if (!continueUpload) {
              try {
                this.$emit("closeTransferPanel");
              } catch (err) {
                console.error(err);
              }

              this.costImportMsg = "请核对补录成本差额";
              if (res.data.message == "error") {
                this.costImportMsg = "存在异常，请下载文件查看";
                this.isCancel = true;
              } else {
                this.isCancel = false;
              }

              this.costFile = res.data.data;
              this.dialogVisible3 = true;
            } else {
              this.$message.success("提交成功");
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    continueUpload() {
      if (!this.isCancel) {
        this.costChargeImport(true);
        setTimeout(() => {
          this.query();
        }, 500);
      }
      this.fileList = [];
      this.dialogVisible3 = false;
    },
    downloadCostFile() {
      var byteCharacters = atob(this.costFile);
      var byteNumbers = new Array(byteCharacters.length);
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      var byteArray = new Uint8Array(byteNumbers);
      let blob = new Blob([byteArray], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      let objectUrl = URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = objectUrl;
      a.download = "costImport_return.xlsx";
      a.click();

      if (this.isCancel) {
        this.dialogVisible3 = false;
      }
    },
    exportData() {

      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择订单");
        return false;
      }
      
      let ids = new Array();
      this.multipleSelection.forEach((d, i) => {
        ids.push(d.id);
      });

      let batchIds = [];
      this.conditions.batchIdTextArea.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          batchIds.push(d);
        }
      });

      let data = {
        ids: ids,
        batchIds: batchIds,
        supplierId: this.conditions.supplierId,
        serviceTypeId: this.conditions.serviceTypeId,
        status: this.conditions.status,
        startDate: this.conditions.startDate,
        endDate: this.conditions.endDate
      };

      this.$request1({
        method: 'POST',
        url: '/batch/cost-charge/download',
        headers: { "content-type": "application/json" },
        responseType: "json",
        data: data
      }).then(res => {
        if (!res.data.success) {
          this.$notify.error({
            title: "错误消息",
            message: res.data.message
          });
          return;
        }
        var byteCharacters = atob(res.data.data);

        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        let blob = new Blob([byteArray], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        let objectUrl = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = objectUrl;
        a.download = "batch_cost_charge.xlsx";
        a.click();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/batchcostmanage.vue